import { IORGDataTableQueryState } from 'shared-it-appmod-ui';
import { IFireDispatch } from 'src/models/fire-dispatch.model';
import { DispatchListTab } from 'src/constants';
import { IFireDispatchState, actionTypes } from 'src/ducks/fire-dispatch.duck';
import { IStatus } from 'src/libraries/thunk.library';

export const getFireDispatchStatus = (
  state: IFireDispatchState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };

export const countCategory = (data?: IFireDispatch[]) => {
  return data?.map((fireDispatch) => fireDispatch.tailNumber).length;
};

export const getTableListParams = (
  params: IORGDataTableQueryState,
  currentTab?: DispatchListTab
): Partial<IORGDataTableQueryState> => {
  const { keyword, ...data } = params;
  if (keyword) {
    data.filters = [
      ...(data.filters ?? []),
      {
        name: 'dispatchId',
        value: keyword,
      },
    ];
  }

  if (data.filters) {
    data.filters.forEach((filter) => {
      data[filter.name] = filter.value;
    });
  }
  if (data.dispatchDate && data.year !== undefined) {
    const dispatchDateStart = data.dispatchDate[0];
    const dispatchDateEnd = data.dispatchDate[1];
    data.dispatchDateStart = dispatchDateStart;
    data.dispatchDateEnd = dispatchDateEnd;
    data.year = data.dispatchDate.year;
  } else if (!data.year) {
    const year = new Date().getFullYear();
    const dispatchDateStart = `01/01/${year}`;
    const dispatchDateEnd = `12/31/${year}`;
    data.dispatchDateStart = dispatchDateStart;
    data.dispatchDateEnd = dispatchDateEnd;
    data.year = year;
  }

  switch (currentTab) {
    case DispatchListTab.Cancelled: {
      data.status = 'Cancelled';
      break;
    }

    case DispatchListTab.Dispatched: {
      data.status = 'Dispatched';
      break;
    }

    case DispatchListTab.InFlight: {
      data.status = 'In-Flight';
      break;
    }

    case DispatchListTab.Landed: {
      data.status = 'Landed';
      break;
    }

    case DispatchListTab.Completed: {
      data.status = 'Completed';
      break;
    }

    default: {
      break;
    }
  }

  return data;
};

export const getCSVContent = (
  data: (string | null | number | undefined)[][],
  title?: string[]
) => {
  let content = title
    ? `<table border="1" cellspacing="1" cellpadding="2"><tr><th bgcolor="000080" nowrap><font color="FFFFFF">${title.join(
        '</font></th><th bgcolor="000080" nowrap><font color="FFFFFF">'
      )}</font></th></tr>\n`
    : '';
  data.forEach((value, index) => {
    content += `<tr><td bgcolor="${index % 2 === 0 ? '#e8ffff' : '#fff'}">`;
    for (let j = 0; j < value.length; j++) {
      const innerValue = value[j] === null ? '' : (value[j] ?? '').toString();
      let result = innerValue.replace(/"/g, '""');

      if (result.search(/("|,|\n)/g) >= 0) {
        result = `${result}`;
      }

      if (j > 0) {
        if (value[j] === 'Cancelled') {
          content += '</td><td bgcolor="#ffd87d"><font color="#ff0000">';
        } else {
          content += `</td><td bgcolor="${
            index % 2 === 0 ? '#e8ffff' : '#fff'
          }"><font color="#000">`;
        }
      }

      content += result;
    }

    content += '</font></td></tr>\n \n';
  });

  content += '</table>';

  return `data:application/vnd.ms-excel, ${encodeURIComponent(content)}`;
};
